"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
var decodersState = reselect_1.createSelector(moduleState, function (state) { return state.decoders; });
exports.decoders = reselect_1.createSelector(decodersState, function (contentRoot) { return contentRoot.data; });
exports.decodersIsLoading = reselect_1.createSelector(decodersState, function (contentRoot) { return contentRoot.isLoading; });
exports.decodersError = reselect_1.createSelector(decodersState, function (contentRoot) { return contentRoot.error; });
var recordState = reselect_1.createSelector(moduleState, function (state) { return state.record; });
exports.recordIsLoading = reselect_1.createSelector(recordState, function (contentRoot) { return contentRoot.isLoading; });
exports.recordError = reselect_1.createSelector(recordState, function (contentRoot) { return contentRoot.error; });
//# sourceMappingURL=selectors.js.map